import client from "../client";

export interface CommentRequest {
  text?: string;
}

export default function API(request: CommentRequest): Promise<any> {
  return client
    .post(`gameinhouse/comment/comment`, request)
    .then((response) => response.data);
}
